import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";
import { QrCode, Check, Crown } from "lucide-react";

const TAG_IMGS = {
  frente_a: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/f22418112f2966867b85da38473d2137c6053e2066fd1c724129b5bdc70d0cde.jpeg",
  verso_a: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/db60bef5c96b33c24fcdef71926a287149b602ae25b384e764e34086cf00ef0d.jpeg",
  frente_b: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/131c20efee8254b8e87f3e2071bdba7ed239f936791c78f7d70ec8c5cc53a82a.jpeg",
  verso_b: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/0e2b2801c70a3c728287f430e13a4ee983c000df8e081432e0c9727768260456.jpeg",
  latao_redonda_frente: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/57d70a7eacaf05f05e81a86215770dc89fdb3baacb2fa587825f652131196726.jpeg",
  latao_redonda_verso: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/08b816a0c1f6bf36bc414a05834e63b03ea3110024d63664f52271c9791bbb8a.jpeg",
  latao_plaqueta_frente: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/57d79a4d22fac81f164f8db5da17dc553f75a522daf15c5abbd27ff5bb073bd2.jpeg",
  latao_plaqueta_verso: "https://static.prod-images.emergentagent.com/jobs/01926a1e-4895-486f-9e22-5f463bd4d108/images/05223b092ee837adbda706325e23c8061b279893b5cc389aff708a789d255056.jpeg",
};

const TAGS = [
  { id: "basica", name: "Tag Redonda Coral", price: 39.9, desc: "Redonda em inox polido com anel de silicone coral. Frente: nome do pet + telefone. Verso: marca PetMachine + desenho + QR code.", color: "bg-brand-mintLight text-brand-mintDark", img: TAG_IMGS.frente_a, verso: TAG_IMGS.verso_a },
  { id: "premium", name: "Tag Osso Inox", price: 69, desc: "Formato osso em aço inox escovado, acabamento premium. Frente: nome do pet + telefone. Verso: logo PetMachine Hub + desenho + QR code.", color: "bg-brand-coralLight text-brand-coral", img: TAG_IMGS.frente_b, verso: TAG_IMGS.verso_b },
  { id: "latao_redonda", name: "Tag Redonda Latão", price: 79.9, desc: "Redonda em latão dourado polido com guirlanda e estrelas gravadas. Frente: pata + nome do pet gravado na parte lisa. Verso: marca PetMachine + desenho + QR code.", color: "bg-brand-mustardLight text-brand-mustardDark", img: TAG_IMGS.latao_redonda_frente, verso: TAG_IMGS.latao_redonda_verso, novo: true },
  { id: "latao_plaqueta", name: "Tag Plaqueta Latão Premium", price: 99.9, desc: "Plaqueta retangular de latão dourado com cantos arredondados, estilo militar premium. Frente: pata + nome do pet em grande destaque. Verso: marca PetMachine + desenho + QR code.", color: "bg-brand-coralLight text-brand-coral", img: TAG_IMGS.latao_plaqueta_frente, verso: TAG_IMGS.latao_plaqueta_verso, novo: true },
  { id: "club", name: "Tag Club", price: 0, desc: "Grátis para assinantes PetHub Club — escolha o modelo Redonda Coral ou Osso Inox na confecção. Todos os recursos inclusos.", color: "bg-brand-mustardLight text-brand-mustardDark", clubOnly: true, img: TAG_IMGS.verso_a, verso: TAG_IMGS.verso_b },
];

export default function Shop() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pets, setPets] = useState([]);
  const [petSel, setPetSel] = useState("");
  const [buying, setBuying] = useState("");
  const [addrOpen, setAddrOpen] = useState(false);
  const [addrTag, setAddrTag] = useState(null);
  const [addr, setAddr] = useState({ cep: "", rua: "", numero: "", complemento: "", bairro: "", cidade: "Joinville" });
  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (user) api.get("/pets").then((r) => setPets(r.data)).catch(() => {});
  }, [user]);

  const buy = async (tag) => {
    if (!user) return navigate("/login?next=/loja");
    setAddrTag(tag);
    setAddrOpen(true);
  };

  const confirmPurchase = async () => {
    const tag = addrTag;
    if (!petSel) return toast.error("Escolha o pet — o nome dele será gravado na tag");
    if (!phone) return toast.error("Informe o telefone que será gravado na tag");
    if (!addr.cep || !addr.rua || !addr.numero) return toast.error("Informe CEP, rua e número para a entrega");
    setBuying(tag.id);
    try {
      const r = await api.post("/payments/checkout", { kind: "tag", tag_type: tag.id, pet_id: petSel, phone, address: addr });
      if (r.data.init_point) { window.location.assign(r.data.init_point); return; }
      toast.success(`Pedido aprovado! Código da tag: ${r.data.order.tag_code}. Avisaremos quando a confecção começar.`, { duration: 6000 });
      toast.info("Dica: complete o visual com uma coleira — as de couro levam gravação do nome do pet + telefone + QR code. Receba tudo no seu endereço!", { duration: 9000 });
      setAddrOpen(false);
      navigate("/app");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro no checkout");
    } finally {
      setBuying("");
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-6 py-12" data-testid="shop-page">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <span className="inline-flex items-center gap-2 bg-brand-coralLight text-brand-coral text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
          <QrCode className="w-3.5 h-3.5" /> Loja PetMachine Hub
        </span>
        <h1 className="text-3xl sm:text-4xl font-bold font-heading text-brand-graphite">Tag inteligente com QR Code</h1>
        <p className="text-muted-foreground mt-3">Quem encontrar seu pet escaneia a tag, vê as informações essenciais e você recebe um alerta na hora. Entrega em Joinville.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {TAGS.map((t) => (
          <div key={t.id} className={`bg-white rounded-3xl p-7 border-2 card-hover flex flex-col ${t.id === "premium" ? "border-brand-coral shadow-lg" : "border-transparent"}`} data-testid={`tag-card-${t.id}`}>
            <div className="relative mb-4">
              {t.novo && <span className="absolute top-2 left-2 z-10 bg-brand-coral text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow" data-testid={`tag-novo-${t.id}`}>NOVO</span>}
              <img src={t.img} alt={`${t.name} — frente`} className="w-full h-44 object-cover rounded-2xl" data-testid={`tag-img-${t.id}`} />
              <img src={t.verso} alt={`${t.name} — verso`} className="absolute -bottom-3 -right-2 w-16 h-16 object-cover rounded-xl border-2 border-white shadow-md" title="Verso" />
            </div>
            <span className={`self-start text-xs font-semibold px-3 py-1 rounded-full ${t.color}`}>{t.name}</span>
            <p className="font-heading font-extrabold text-4xl text-brand-graphite mt-4">
              {t.price === 0 ? "Grátis" : <>R$ {Number(t.price).toFixed(2).replace(".", ",")}</>}
            </p>
            <p className="text-sm text-muted-foreground mt-3 flex-1">{t.desc}</p>
            <ul className="text-sm space-y-2 mt-4 mb-6">
              {["Página pública do pet", "Alerta de escaneamento", "Modo desaparecido"].map((f) => (
                <li key={f} className="flex items-center gap-2 text-brand-graphite"><Check className="w-4 h-4 text-brand-mint" />{f}</li>
              ))}
            </ul>
            <Button onClick={() => buy(t)} disabled={buying === t.id}
              className={`rounded-full h-11 font-semibold ${t.id === "club" ? "bg-brand-mustard hover:bg-brand-mustardDark text-brand-graphite" : "bg-brand-coral hover:bg-brand-coralDark text-white"}`}
              data-testid={`buy-tag-${t.id}`}>
              {buying === t.id ? "Processando..." : t.id === "club" ? "Resgatar grátis (Club)" : "Comprar agora"}
            </Button>
          </div>
        ))}
      </div>

      {!user?.club?.active && (
        <div className="mt-10 bg-brand-graphite rounded-3xl p-8 text-center text-white" data-testid="club-upsell">
          <Crown className="w-8 h-8 text-brand-mustard mx-auto mb-3" />
          <p className="font-heading font-semibold text-xl">Assinantes PetHub Club ganham a Tag Club de graça</p>
          <p className="text-white/60 text-sm mt-2">Early Bird: R$ 9,90/mês vitalício para os 100 primeiros.</p>
          <Link to="/planos" data-testid="shop-club-cta"><Button className="bg-brand-mustard hover:bg-brand-mustardDark text-brand-graphite rounded-full mt-5 font-semibold">Conhecer o Club</Button></Link>
        </div>
      )}

      <div className="mt-6 bg-white rounded-3xl p-8 border text-center" data-testid="collars-upsell">
        <p className="font-heading font-semibold text-xl text-brand-graphite">Complete o visual: coleiras</p>
        <p className="text-sm text-muted-foreground mt-2 max-w-xl mx-auto">Escolha o modelo, passe a medida do pescoço e receba no seu endereço. Nas de couro, gravamos o nome do pet + seu telefone + QR code.</p>
        <Link to="/coleiras" data-testid="shop-collars-cta">
          <Button variant="outline" className="rounded-full mt-4 border-brand-mint text-brand-mintDark hover:bg-brand-mintLight">Ver coleiras</Button>
        </Link>
      </div>

      <Dialog open={addrOpen} onOpenChange={setAddrOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Endereço de entrega da tag</DialogTitle></DialogHeader>
          <div className="space-y-3" data-testid="address-form">
            <div className="bg-brand-coralLight rounded-xl p-3 text-xs text-brand-graphite">
              <p className="font-semibold mb-0.5">Gravação da tag</p>
              <p><strong>Frente:</strong> nome do pet + seu telefone • <strong>Verso:</strong> marca PetMachine + desenho + QR code</p>
            </div>
            {pets.length > 0 ? (
              <div>
                <Label>Gravar para qual pet? *</Label>
                <Select value={petSel} onValueChange={setPetSel}>
                  <SelectTrigger className="mt-1" data-testid="tag-pet-select"><SelectValue placeholder="Escolha o pet" /></SelectTrigger>
                  <SelectContent>
                    {pets.map((p) => <SelectItem key={p.pet_id} value={p.pet_id}>{p.name}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
            ) : (
              <p className="text-xs bg-brand-cream rounded-xl p-3 text-muted-foreground">
                Você ainda não tem pets cadastrados. <Link to="/app" className="text-brand-coral font-semibold">Cadastre um pet</Link> antes de comprar a tag.
              </p>
            )}
            <div><Label>Telefone para gravar na tag *</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="(47) 99999-9999" className="mt-1" data-testid="tag-phone-input" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>CEP *</Label><Input value={addr.cep} onChange={(e) => setAddr({ ...addr, cep: e.target.value })} placeholder="89200-000" className="mt-1" data-testid="addr-cep" /></div>
              <div><Label>Cidade</Label><Input value={addr.cidade} onChange={(e) => setAddr({ ...addr, cidade: e.target.value })} className="mt-1" data-testid="addr-cidade" /></div>
            </div>
            <div><Label>Rua *</Label><Input value={addr.rua} onChange={(e) => setAddr({ ...addr, rua: e.target.value })} className="mt-1" data-testid="addr-rua" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Número *</Label><Input value={addr.numero} onChange={(e) => setAddr({ ...addr, numero: e.target.value })} className="mt-1" data-testid="addr-numero" /></div>
              <div><Label>Complemento</Label><Input value={addr.complemento} onChange={(e) => setAddr({ ...addr, complemento: e.target.value })} className="mt-1" data-testid="addr-complemento" /></div>
            </div>
            <div><Label>Bairro</Label><Input value={addr.bairro} onChange={(e) => setAddr({ ...addr, bairro: e.target.value })} className="mt-1" data-testid="addr-bairro" /></div>
            <Button onClick={confirmPurchase} disabled={!!buying} className="w-full bg-brand-coral hover:bg-brand-coralDark text-white rounded-full" data-testid="confirm-purchase-btn">
              {buying ? "Processando..." : `Confirmar compra${addrTag ? ` — ${addrTag.name}` : ""}`}
            </Button>
            <p className="text-xs text-center text-muted-foreground">Você receberá um aviso quando a tag entrar em confecção.</p>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
